// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3351":"css/app.6771","5338":"css/admin-app.6771"}[chunkId] + ".css";
};